import React from "react";
import { FaGithub, FaLinkedin, FaRegEnvelope } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { useLanguage } from "../LanguageContext";
import useScrollReveal from "../../utils/useScrollReveal";

import "../../assets/css/contact.css";
import "../../assets/css/font.css";

function Contact() {
  const { t } = useLanguage();
  const [ref, visible] = useScrollReveal();

  return (
    <section
      id="contact"
      ref={ref}
      className={`section contact reveal ${visible ? "is-visible" : ""}`}
    >
      <div className="container contact-inner">
        <span className="eyebrow">{t.contact.eyebrow}</span>
        <h2 className="section-heading">{t.contact.title}</h2>
        <p className="contact-text">{t.contact.text}</p>

        <a
          className="button button-primary contact-cta"
          href="mailto:vinicius.gabriel.px@gmail.com"
        >
          <FaRegEnvelope aria-hidden="true" />
          {t.contact.ctaLabel}
        </a>

        <div className="contact-links">
          <a
            href="https://www.linkedin.com/in/viniciuspx"
            target="_blank"
            rel="noreferrer"
            className="contact-link"
          >
            <FaLinkedin aria-hidden="true" /> {t.contact.linkedIn}
          </a>
          <a
            href="https://github.com/viniciuspx"
            target="_blank"
            rel="noreferrer"
            className="contact-link"
          >
            <FaGithub aria-hidden="true" /> {t.contact.github}
          </a>
          <span className="contact-link contact-location">
            <IoLocationOutline aria-hidden="true" /> {t.contact.location}
          </span>
        </div>
      </div>
    </section>
  );
}

export default Contact;
